import { Box, Container, Typography } from "@mui/material";
export function Footer() {
  return (
    <Box
      sx={{
        py: 4,
        backgroundColor: "#333",
        color: "white",
        textAlign: "center",
      }}>
      <Container maxWidth="lg">
        <Typography variant="body2">
          © 2024 GiveShare. All rights reserved.
        </Typography>
      </Container>
    </Box>
  );
}
